import { ImageName } from "@mcleod/images";
import { Label, Panel, TreeNode } from "@mcleod/components";
import { HomePageEditor } from "./HomePageEditor";
import { WidgetMenuItem } from "./WidgetMenuItem";

export class WidgetMenuGroup extends Panel {
    node: TreeNode;
    labelCount: Label;
    homeEditor: HomePageEditor;
    constructor(node: TreeNode) {
        super({ padding: 0 });
        this.node = node;
        node.expanded = true;
        const label = (node._component as Label);
        label.setProps({ imageName: ImageName.boxAdd, color: "subtle.darker", fontBold: true, rowBreak: false });
        this.labelCount = new Label({ paddingLeft: 0, fontBold: true, })
        this.add(node._component, this.labelCount);
        this.node.onCreateImage = (node: TreeNode) => {
            label.imageName = node.expanded ? ImageName.boxHide : ImageName.boxAdd;
        };
    }

    syncMenu() {
        let widgetAddedCount = 0;
        this.node.recurseChildren(child => {
            if (child._component instanceof WidgetMenuItem) {
                child._component.syncMenuItem();
                if (child._component.widgetAdded)
                    widgetAddedCount++;
            }
        })
        this.labelCount.text = widgetAddedCount > 0 ? widgetAddedCount.toString() : null;
    }
}
